/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ApprovePayoutRequestDto,
  BulkApprovePayoutRequestsDto,
  BulkApprovePayoutRequestsResultDto,
  CreateFsmPayoutRequestDto,
  CreateOpportunityClaimPayoutRequestDto,
  DenyPayoutRequestDto,
  FsmPayoutRequestDetailDto,
  ListPayoutRequestsParams,
  PayoutRequestDto,
  PayoutRequestEvidenceDto,
  PayoutRequestListItemDtoPaginatedResult,
  PayoutRequestSourceDto,
  PayoutRequestStatsDto,
  ReturnPayoutRequestDto
} from '.././types';




  /**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const listPayoutRequests = <TData = AxiosResponse<PayoutRequestListItemDtoPaginatedResult>>(
    params?: ListPayoutRequestsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-requests`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const getPayoutRequestStats = <TData = AxiosResponse<PayoutRequestStatsDto>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-requests/stats`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestById = <TData = AxiosResponse<PayoutRequestDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-requests/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestSource = <TData = AxiosResponse<PayoutRequestSourceDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-requests/${id}/source`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getFsmPayoutRequestDetail = <TData = AxiosResponse<FsmPayoutRequestDetailDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-requests/fsm/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestEvidence = <TData = AxiosResponse<PayoutRequestEvidenceDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-requests/${id}/evidence`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_CREATE
 */
export const createPayoutRequestFromOpportunityClaim = <TData = AxiosResponse<PayoutRequestDto>>(
    createOpportunityClaimPayoutRequestDto: CreateOpportunityClaimPayoutRequestDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-requests/from-opportunity-claim`,
      createOpportunityClaimPayoutRequestDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_CREATE
 */
export const createPayoutRequestFromFsmCompletedWork = <TData = AxiosResponse<PayoutRequestDto>>(
    createFsmPayoutRequestDto: CreateFsmPayoutRequestDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-requests/from-fsm-event`,
      createFsmPayoutRequestDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_APPROVE
 */
export const approvePayoutRequest = <TData = AxiosResponse<PayoutRequestDto>>(
    id: string,
    approvePayoutRequestDto: ApprovePayoutRequestDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-requests/${id}/approve`,
      approvePayoutRequestDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_BULK_APPROVE
 */
export const bulkApprovePayoutRequests = <TData = AxiosResponse<BulkApprovePayoutRequestsResultDto>>(
    bulkApprovePayoutRequestsDto: BulkApprovePayoutRequestsDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-requests/bulk-approve`,
      bulkApprovePayoutRequestsDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_DENY
 */
export const denyPayoutRequest = <TData = AxiosResponse<PayoutRequestDto>>(
    id: string,
    denyPayoutRequestDto: DenyPayoutRequestDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-requests/${id}/deny`,
      denyPayoutRequestDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_RETURN
 */
export const returnPayoutRequest = <TData = AxiosResponse<PayoutRequestDto>>(
    id: string,
    returnPayoutRequestDto: ReturnPayoutRequestDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-requests/${id}/return`,
      returnPayoutRequestDto,options
    );
  }
export type ListPayoutRequestsResult = AxiosResponse<PayoutRequestListItemDtoPaginatedResult>
export type GetPayoutRequestStatsResult = AxiosResponse<PayoutRequestStatsDto>
export type GetPayoutRequestByIdResult = AxiosResponse<PayoutRequestDto>
export type GetPayoutRequestSourceResult = AxiosResponse<PayoutRequestSourceDto>
export type GetFsmPayoutRequestDetailResult = AxiosResponse<FsmPayoutRequestDetailDto>
export type GetPayoutRequestEvidenceResult = AxiosResponse<PayoutRequestEvidenceDto>
export type CreatePayoutRequestFromOpportunityClaimResult = AxiosResponse<PayoutRequestDto>
export type CreatePayoutRequestFromFsmCompletedWorkResult = AxiosResponse<PayoutRequestDto>
export type ApprovePayoutRequestResult = AxiosResponse<PayoutRequestDto>
export type BulkApprovePayoutRequestsResult = AxiosResponse<BulkApprovePayoutRequestsResultDto>
export type DenyPayoutRequestResult = AxiosResponse<PayoutRequestDto>
export type ReturnPayoutRequestResult = AxiosResponse<PayoutRequestDto>
